import { useCallback, useEffect, useMemo, useState } from "react"
import api from "../services/api"
import { DEFAULT_ORGANIZATION_OPTION } from "../constants/defaultOrganization"

export const useOrganizations = () => {
  const [organizations, setOrganizations] = useState([])

  const fetchOrganizations = useCallback(async () => api.getOrganizations(), [])

  useEffect(() => {
    fetchOrganizations().then(response => {
      setOrganizations(response.data)
    })
  }, [])

  const organizationOptions = useMemo(
    () => [
      DEFAULT_ORGANIZATION_OPTION,
      ...organizations.map(org => ({
        value: org.id,
        label: org.name,
      })),
    ],
    [organizations]
  )

  return { organizations, organizationOptions, fetchOrganizations }
}
